import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import React from "react";
import { TextField } from "./TextField.js";

interface Props {
  id?: string;
  name: string;
  label: string;
  autoComplete?: string;
}

export const PasswordField = ({
  name,
  label,
  id,
  autoComplete = "off",
}: Props) => {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <TextField
      id={id}
      name={name}
      type={showPassword ? "text" : "password"}
      label={label}
      autoComplete={autoComplete}
      required
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(state => !state)}
                onMouseDown={e => e.preventDefault()}
                edge="end"
                tabIndex={-1}
                size="large"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
